import { useLocalSearchParams } from "expo-router";
import { PublicRegisterScreen } from "../../../../src/components/PublicRegisterScreen";

export default function RegisterRoute() {
  const params = useLocalSearchParams<{ funeralHomeId: string; slug: string; event: string }>();
  const first = (value: string | string[] | undefined) => Array.isArray(value) ? value[0] ?? "" : value ?? "";
  return <PublicRegisterScreen funeralHomeId={first(params.funeralHomeId)} slug={first(params.slug)} eventId={first(params.event)} />;
}
